require('bootstrap/dist/js/bootstrap.min');
import initializeFancybox from './fancybox';
import initializeFormValidation from "./formValidation";
import initializeForm from "./form";

const initializeBurgerMenu = () => {
  // toggle mobile menu
  const windowSize = window.innerWidth;

  const mainNavigationContainer = document.querySelector('nav');
  const collapsedNavigation = document.querySelector('.navbar-collapse');
  const menuBurger = document.querySelector('.navbar-burger');
  const menuClose = document.querySelector('.navbar-burger__close');
  const headerElement = document.querySelector('header');
  const headerLogo = headerElement.querySelector('.header__logo');

  if (windowSize < 992) {
    menuBurger.classList.remove('hidden');

    menuBurger.addEventListener('click', () => {
      menuBurger.classList.add('hidden');
      menuClose.classList.remove('hidden');

      collapsedNavigation.classList.add('show');

      mainNavigationContainer.classList.add('opened');
      headerElement.classList.add('mobile-menu-opened');
      headerLogo.classList.add('invert');
    })

    menuClose.addEventListener('click', () => {
      menuClose.classList.add('hidden');
      menuBurger.classList.remove('hidden');

      collapsedNavigation.classList.remove('show');

      mainNavigationContainer.classList.remove('opened');
      headerElement.classList.remove('mobile-menu-opened');
      headerLogo.classList.remove('invert');
    })
  } else {
    menuBurger.classList.add('hidden');
  }
}

let resizeListener;
window.addEventListener('resize', () => {
  initializeBurgerMenu();
});

initializeBurgerMenu();

initializeFancybox();
initializeFormValidation();
initializeForm();
